export const HIT_VALIDATION_WLA = 'HIT_VALIDATION_WLA';
export const GET_VALIDATION_WLA = 'GET_VALIDATION_WLA';

export const HIT_ON_SAVE_WLA = 'HIT_ON_SAVE_WLA';

export const HIT_WORKER_TYPE_CREATE = 'HIT_WORKER_TYPE_CREATE';

export const HIT_WORKER_TYPE_UPDATE = 'HIT_WORKER_TYPE_UPDATE';

export const HIT_WORKER_TYPE_LIST = 'HIT_WORKER_TYPE_LIST';
export const GET_WORKER_TYPE_LIST = 'GET_WORKER_TYPE_LIST';

export const HIT_ACTIVITY_TYPE_LIST = 'HIT_ACTIVITY_TYPE_LIST';
export const GET_ACTIVITY_TYPE_LIST = 'GET_ACTIVITY_TYPE_LIST';

// dashboard

export const HIT_WLA_DASHBOARD_EMPLOYEE = 'HIT_WLA_DASHBOARD_EMPLOYEE';
export const GET_WLA_DASHBOARD_EMPLOYEE = 'GET_WLA_DASHBOARD_EMPLOYEE';

export const HIT_WLA_DASHBOARD_DEPARTEMENT = 'HIT_WLA_DASHBOARD_DEPARTEMENT';
export const GET_WLA_DASHBOARD_DEPARTEMENT = 'GET_WLA_DASHBOARD_DEPARTMENET';

export const HIT_WLA_DASHBOARD_DIVISION = 'HIT_WLA_DASHBOARD_DIVISION';
export const GET_WLA_DASHBOARD_DIVISION = 'GET_WLA_DASHBOARD_DIVISION';

export const HIT_WLA_DASHBOARD_JOBLVL = 'HIT_WLA_DASHBOARD_JOBLVL';
export const GET_WLA_DASHBOARD_JOBLVL = 'GET_WLA_DASHBOARD_JOBLVL';

export const HIT_WLA_STATUS = 'HIT_WLA_STATUS';

// status wla

export const GET_WLA_LIST = 'GET_WLA_LIST';
export const GET_WLA_DETAIL = 'GET_WLA_DETAIL';
export const HIT_WLA_LIST = 'HIT_WLA_LIST';
export const HIT_WLA_DETAIL = 'HIT_WLA_DETAIL';

export const HIT_REGION_LIST = 'HIT_REGION_LIST';
export const GET_REGION_LIST = 'GET_REGION_LIST';

// limit FTE

export const HIT_LIST_LIMIT_FTE = 'HIT_LIST_LIMIT_FTE';
export const HIT_LIST_CUSTOM_CATEGORY = 'HIT_LIST_CUSTOM_CATEGORY';
export const GET_LIST_CUSTOM_CATEGORY = 'GET_LIST_CUSTOM_CATEGORY';
export const HIT_LIST_LIMIT_FTE_PUBLIC = 'HIT_LIST_LIMIT_FTE_PUBLIC';
export const GET_LIST_LIMIT_FTE = 'GET_LIST_LIMIT_FTE';
export const HIT_CREATE_FTE = 'HIT_CREATE_FTE';
export const HIT_UPDATE_FTE = 'HIT_UPDATE_FTE';

// export data
export const HIT_EXPORT_DATA_OVERALL = 'HIT_EXPORT_DATA_OVERALL';
export const GET_EXPORT_DATA_OVERALL = 'GET_EXPORT_DATA_OVERALL';
export const HIT_EXPORT_DATA_ACTIVITY = 'HIT_EXPORT_DATA_ACTIVITY';
export const GET_EXPORT_DATA_ACTIVITY = 'GET_EXPORT_DATA_ACTIVITY';
// export data

export const HIT_STRUCTURE_EMPLOYEE = 'HIT_STRUCTURE_EMPLOYEE';
export const GET_STRUCTURE_EMPLOYEE = 'GET_STRUCTURE_EMPLOYEE';

export const HIT_WLA_DASHBOARD_EMPLOYEE_REGION = 'HIT_WLA_DASHBOARD_EMPLOYEE_REGION';
export const GET_WLA_DASHBOARD_EMPLOYEE_REGION = 'GET_WLA_DASHBOARD_EMPLOYEE_REGION';

// other category
export const HIT_WLA_OC_BOARD = 'HIT_WLA_OC_BOARD';
export const GET_WLA_OC_BOARD = 'GET_WLA_OC_BOARD';

export const HIT_WLA_OC_LIST = 'HIT_WLA_OC_LIST';
export const GET_WLA_OC_LIST = 'GET_WLA_OC_LIST';

export const HIT_WLA_OC_CREATE = 'HIT_WLA_OC_CREATE';
export const GET_WLA_OC_CREATE = 'GET_WLA_OC_CREATE';

export const HIT_WLA_OC_UPDATE = 'HIT_WLA_OC_UPDATE';
export const GET_WLA_OC_UPDATE = 'GET_WLA_OC_UPDATE';

export const HIT_WLA_OC_DEPARTEMENT = 'HIT_WLA_OC_DEPARTEMENT';
export const GET_WLA_OC_DEPARTEMENT = 'GET_WLA_OC_DEPARTEMENT';

export const HIT_WLA_OC_ORG = 'HIT_WLA_OC_ORG';
export const GET_WLA_OC_ORG = 'GET_WLA_OC_ORG';

export const HIT_WLA_OC_EMPLOYEE = 'HIT_WLA_OC_EMPLOYEE';
export const GET_WLA_OC_EMPLOYEE = 'GET_WLA_OC_EMPLOYEE';
// other category

export const HIT_WLA_ASSESSMENT = 'HIT_WLA_ASSESSMENT';

export const GET_WLA_LIST_TEMPLATE = 'GET_WLA_LIST_TEMPLATE';
export const HIT_WLA_LIST_TEMPLATE = 'HIT_WLA_LIST_TEMPLATE';
export const HIT_WLA_SUBMIT_TEMPLATE = 'HIT_WLA_SUBMIT_TEMPLATE';

export const HIT_WLA_PROGRESS_SUMMARY = 'HIT_WLA_PROGRESS_SUMMARY';
export const GET_WLA_PROGRESS_SUMMARY = 'GET_WLA_PROGRESS_SUMMARY';

export const HIT_WLA_CHART_PROCESS = 'HIT_WLA_CHART_PROCESS';
export const GET_WLA_CHART_PROCESS = 'GET_WLA_CHART_PROCESS';

export const HIT_WLA_DETAIL_STRUCTURE = 'HIT_WLA_DETAIL_STRUCTUR';
export const GET_WLA_DETAIL_STRUCTURE = 'GET_WLA_DETAIL_STRUCTUR';

export const HIT_WLA_BAR_CHART = 'HIT_WLA_BAR_CHART';
export const GET_WLA_BAR_CHART = 'GET_WLA_BAR_CHART';

export const HIT_WLA_DETAIL_ORG = 'HIT_WLA_DETAIL_ORG';
export const GET_WLA_DETAIL_ORG = 'GET_WLA_DETAIL_ORG';

export const HIT_WLA_ORG_PROCESS = 'HIT_WLA_ORG_PROCESS';
export const GET_WLA_ORG_PROCESS = 'GET_WLA_ORG_PROCESS';

export const HIT_WLA_LIST_PROCESS = 'HIT_WLA_LIST_PROCESS';
export const GET_WLA_LIST_PROCESS = 'GET_WLA_LIST_PROCESS';
